import { forwardRef } from "react";
import type { CheckboxProps } from "./interface";
import { FaCheck } from "react-icons/fa6";

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, ...props }, ref) => {
    return (
      <div className="flex items-center gap-2">
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            {...props}
            className="peer appearance-none w-4 h-4 border border-[#D8DCDE] rounded cursor-pointer checked:bg-blue-600 checked:border-blue-600"
          />
          <FaCheck className="absolute top-[3px] left-0.5 w-3 h-3 text-white pointer-events-none opacity-0 peer-checked:opacity-100" />
        </div>
        {label && <label className="font-semibold text-sm cursor-pointer">{label}</label>}
      </div>
    );
  }
);
